import { createApiClient } from './ApiClientFactory';

const BASE_URL = import.meta.env.VITE_BASE_URL || 'http://localhost:5000';
const apiClient = createApiClient(BASE_URL);

// x-org-id is now injected globally by ApiClientFactory

export default {
    /**
     * Create a new device
     * @param {Object} payload Device data
     * @param {String} projectId Optional Project ID
     */
    async createDevice(payload, projectId = null) {
        const config = {};
        if (projectId) {
            config.headers = { 'x-project-id': projectId };
        }
        
        const response = await apiClient.post('/devices', payload, config);
        const body = response.data;
        return body?.data?.item ?? body;
    },

    /**
     * List devices with optional filters
     * @param {Object} params Query parameters (page, limit, type, status)
     */
    async getDevices(params = {}) {
        const config = {
            params
        };
        
        const response = await apiClient.get('/devices', config);
        return response.data;
    },

    /**
     * Get device statistics
     */
    async getDeviceStats() {
        const response = await apiClient.get('/devices/stats');
        return response.data;
    },

    /**
     * Get single device details
     * @param {String} deviceId Device ID
     */
    async getDevice(deviceId) {
        const response = await apiClient.get(`/devices/${deviceId}`);
        const body = response.data;
        return body?.data?.item ?? body;
    },

    /**
     * Update device details
     * @param {String} deviceId Device ID
     * @param {Object} payload Update data
     */
    async updateDevice(deviceId, payload) {
        const response = await apiClient.put(`/devices/${deviceId}`, payload);
        const body = response.data;
        return body?.data?.item ?? body;
    },

    /**
     * Delete a device
     * @param {String} deviceId Device ID
     */
    async deleteDevice(deviceId) {
        const response = await apiClient.delete(`/devices/${deviceId}`);
        return response.data;
    },

    /**
     * Update device status (e.g. online/offline, battery)
     * @param {String} deviceId Device ID
     * @param {Object} statusData Status update data
     */
    async updateDeviceStatus(deviceId, statusData) {
        const response = await apiClient.patch(`/devices/${deviceId}/status`, statusData);
        return response.data;
    },

    /**
     * Assign device to project or asset
     * @param {String} deviceId Device ID
     * @param {Object} assignmentData Assignment data { project_id, asset_id, assigned_to }
     */
    async assignDevice(deviceId, assignmentData) {
        const response = await apiClient.patch(`/devices/${deviceId}/assign`, assignmentData);
        return response.data;
    }
}